module.exports = __webpack_public_path__ + "images/stickers/taco-pixel.811cfaa5a2bd5e70e84a.png";